<template>
  <div>
    <field-label :field="field"></field-label>
    <v-select
      :value="value"
      :items="field.options"
      :menu-props="{ zIndex: 1000 }"
      :rules="rules"
      :disabled="field.disabled"
      @change="input"
      dense
      outlined
    ></v-select>
  </div>
</template>

<script>
import FieldLabel from '@/components/editor/partials/FieldLabel'

export default {
  name: 'SelectField',
  props: ['value', 'field'],
  components: {
    FieldLabel
  },
  computed: {
    rules() {
      let rules = this.field.rules || []

      return rules.map(rule => this.$store.state.editor.validation.rules[rule])
    }
  },
  methods: {
    input(value) {
      this.$emit('update:value', value)
    },
    setDefaultValue() {
      // TODO - fix default value set up
      // if (this.value === undefined && this.field.default !== undefined) {
      //   this.input(this.field.default)
      // }
    }
  },
  mounted() {
    this.setDefaultValue()
  }
}
</script>
